import { useQuery } from "@tanstack/react-query";
import { continueQuiz } from "@/services/apiQuiz";

export function useContinueQuiz({ courseId, lectureId, quizId, attemptId }) {
  const {
    isPending,
    data: quizAttemptData,
    isSuccess,
    error,
  } = useQuery({
    queryKey: ["quiz_attempt", courseId, lectureId, quizId, attemptId],
    queryFn: () => continueQuiz({ courseId, lectureId, quizId, attemptId }),
    retry: false,
  });

  return { isPending, isSuccess, error, quizAttemptData };
}
